import FileAES from '@/util/fileAES';
import Base64Encoder from '@/util/base64encoder';
import ByteEncoder from '@/util/byteEncoder';
import EncryptedFile from "@/models/EncryptedFile";
import TransferInteractionConfiguration from "@/models/TransferInteractionConfiguration";

export default class Metadata {

    public filename!: string;
    public filesize!: number; //if 0 -> Files Are attached as List!
    public chunks!: number;
    public keyAsBase64!: string;
    public b64IVs: string[] = [];
    public saltAsBase64!: string;
    public chunkIds: string[] = [];
    public files: EncryptedFile[] = [];
    public interactionConfiguration?: TransferInteractionConfiguration = new TransferInteractionConfiguration();

    public toString(): string {
        return JSON.stringify(this);
    }

    public static fromString(json: string): Metadata {
        const newInstance = new Metadata();
        const restored = JSON.parse(json);
        return Object.assign(newInstance, restored);
    }

    public async getEncryptedAsBytes(key: CryptoKey, iv: Uint8Array): Promise<Uint8Array> {
        const json: string = this.toString();
        const jsonBytes: Uint8Array = ByteEncoder.stringToBytes(json);
        const aes: FileAES = new FileAES(key);
        const encrypted = await aes.encryptChunk(jsonBytes, iv);
        return new Uint8Array(encrypted);
    }

    public async getEncryptedAsBase64(key: CryptoKey, iv: Uint8Array): Promise<string> {
        const encryptedBytes = await this.getEncryptedAsBytes(key, iv);
        return Base64Encoder.bytesToString(encryptedBytes);
    }

    public static async fromEncryptedBytes(key: CryptoKey, iv: Uint8Array, encryptedBytes: Uint8Array):
    Promise<Metadata> {
        const aes: FileAES = new FileAES(key);
        const decryptedBytes = await aes.decryptChunk(encryptedBytes, iv);
        const json = ByteEncoder.bytesToString(new Uint8Array(decryptedBytes));
        return Metadata.fromString(json);
    }

    public static fromEncryptedBytesAsBase64(key: CryptoKey, iv: Uint8Array, encryptedString: string):
    Promise<Metadata> {
        const bytes = Base64Encoder.stringToBytes(encryptedString);
        return Metadata.fromEncryptedBytes(key, iv, bytes);
    }
}
